import React from 'react';

import styles from './SubscriptionLoader.css';

export function SubscriptionItemLoader() {
    return (
        <div className={styles.root}>
            <div className={styles.loader} />
        </div>
    );
}
